import { useEffect } from 'react';
import AppWrappedRadios from '../../AppWrappedRadios';
import { EPIC_FIELD_KEYS, EPIC_FIELD_OPTIONS } from '../_const';

/**
 * Account Settings Selection input component for Epic/EpicCare stylized to work with Custom App Request Form
 * @param {Object} props properties
 * @returns Custom input
 */
const AccountSettingsSelections = ({ formik, ...props }) => {
	useEffect(() => {
		if (EPIC_FIELD_KEYS.TRAINING in formik?.values) {
			if (formik?.values[EPIC_FIELD_KEYS.TRAINING] === 'No') {
				formik.setFieldValue(
					EPIC_FIELD_KEYS.MODEL_AFTER_SHOW,
					EPIC_FIELD_OPTIONS.MODEL_AFTER_NO
				);
				formik.setFieldTouched(EPIC_FIELD_KEYS.MODEL_AFTER_SHOW, true);
				formik.setFieldTouched(EPIC_FIELD_KEYS.TOGGLE_AMBULATORY, true);
				formik.setFieldTouched(
					EPIC_FIELD_KEYS.TOGGLE_REGISTRATION,
					true
				);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [formik.values[EPIC_FIELD_KEYS.TRAINING]]);

	return (
		<AppWrappedRadios
			label='Account Settings Selection Method'
			formik={{ ...formik }}
			{...props}
		/>
	);
};

export default AccountSettingsSelections;
